export default __webpack_public_path__ + "static/media/image_7.2017852e.jpg";